module.exports = __webpack_public_path__ + "img/territoire.daf1c0bb.jpg";